export const CONTACT = {
  whatsapp: "5591985220587",
  whatsappLabel: "+55 91 98522-0587",
  instagram: "carlosmotta_personal",
  city: "Belém/PA",
  cref: "CREF 036730/PA",
};

export const waLink = (text) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(text)}`;

export const DEFAULT_MSG =
  "Olá, Carlos! Vim pelo site e gostaria de agendar uma aula experimental.";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const EASE = [0.16, 1, 0.3, 1];
